import { useState } from "react";

function Button({ name, onClick, bgColor, color, weight }) {
    const [isHovered, setIsHovered] = useState(false);
    const hoverStyle = isHovered ? {
        backgroundColor: "#f73ce7",
        border: "1px solid #f73ce7",
        color: "white",
    } : {};

    return (
        <button style={{
            padding: "20px",
            border: `1px solid ${bgColor}`,
            borderRadius: "8px",
            fontSize: "18px",
            fontWeight: weight,
            backgroundColor: bgColor,
            color: color,
            transition: "all 0.2s ease",
            ...hoverStyle
        }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={onClick} > {name}</button >
    );
}

export default Button;